module.exports = __webpack_public_path__ + "./assets/flags/japan.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/jpn@2x.png
// module id = 70
// module chunks = 0 1